import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient,
  ) { }

  userProfile(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + '/api/v1/user/details', { withCredentials: true });
  }

  getScorers(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + '/api/v1/user/scorers', { withCredentials: true });
  }

  createScorer(item): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + '/api/v1/user/scorers', JSON.stringify(item), { withCredentials: true });
  }

  getPlayers(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + '/api/v1/player/list', { withCredentials: true });
  }

  createPlayer(item): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + '/api/v1/player/create', JSON.stringify(item), { withCredentials: true });
  }
}
